@if (isVisible) {
    <div class="fixed inset-0 w-screen h-screen overflow-y-auto bg-gray-500 text-slate-900 bg-opacity-70 p-2 z-[100]">
        <div class="flex items-center justify-center pt-20 text-sm">
            <div class="w-[375px] min-h-[200px] bg-slate-50 rounded shadow flex flex-col text-sm">
                <!-- Body -->
                <div class="flex flex-col bg-slate-100 rounded-t" [ngClass]="{'hidden' : isSaving }">
                    <!-- ID -->
                    <div class="grid grid-cols-3 items-center">
                        <div class="text-right p-2 pt-3">ID</div>
                        <div class="p-1 pt-2 col-span-2 border-l text-xs">
                            {{ user!.user.id }}
                        </div>
                    </div>
                    <!-- Username -->
                    <div class="grid grid-cols-3 items-center">
                        <div class="text-right p-2 pt-3">Username</div>
                        <div class="p-1 pt-2 col-span-2 border-l">
                            {{ user!.user.username }}
                        </div>
                    </div>
                    <!-- Email -->
                    <div class="grid grid-cols-3 items-center">
                        <div class="text-right p-2 pt-3">Email</div>
                        <div class="p-1 pt-2 col-span-2 border-l">
                            {{ user!.user.email }}
                        </div>
                    </div>
                    <!-- Role -->
                    <div class="grid grid-cols-3 items-center">
                        <div class="text-right p-2 pt-3">Role</div>
                        <div class="p-1 pt-2 col-span-2 border-l">
                            <select #changeRoleSelect (change)="onRoleSelected(changeRoleSelect.value)" class="p-1 bg-slate-50 w-[20ch] shadow-sm">
                                @for (role of roleTypes ; track role) {
                                    <option [attr.value]="role" [attr.selected]="role === user!.role! ? true : null">{{ role }}</option>
                                }
                            </select>
                        </div>
                    </div>
                    <!-- Permissions -->
                    <div class="grid grid-cols-3 items-start">
                        <div class="text-right p-2 pt-3">Permissions</div>
                        <div class="flex p-1 pt-2 col-span-2 border-l">
                            <div class="flex flex-col gap-2 w-full">
                                <div class="flex flex-col gap-1 overflow-y-auto max-h-[20ch]">
                                    <div class="flex flex-row gap-1">
                                        @if (addablePermissions.length) {
                                            <select #addPermissionSelect class="p-1 bg-slate-50 rounded shadow-sm grow">
                                                @for (permission of addablePermissions ; track permission) {
                                                    <option [attr.value]="permission">{{ permission }}</option>
                                                }
                                            </select>
                                            <button (click)="onAddPermission(addPermissionSelect.value)" class="p-1 rounded shadow-sm bg-slate-50 text-center pr-2 pl-2">
                                                +
                                            </button>
                                        } @else {
                                            <select class="p-1 bg-slate-50 rounded shadow-sm grow text-slate-400">
                                                <option disabled selected value>No Permissions to Add</option>
                                            </select>
                                            <button class="p-1 rounded shadow-sm bg-slate-50 text-center text-slate-400 pr-2 pl-2" disabled="true">
                                                +
                                            </button>
                                        }
                                    </div>
                                    @if (user?.permissions) {
                                        @for (permission of currPermissions ; track permission ) {
                                            <div class="flex flex-row bg-slate-50 rounded shadow-sm p-1">
                                                <div class="grow p-1">{{ permission }}</div>
                                                <button (click)="onRemovePermission(permission)" class="stroke-slate-500 hover:stroke-red-600">
                                                    <svg class="w-4 h-4 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
                                                        <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="closeSvgIcon" />
                                                    </svg>
                                                </button>
                                            </div>
                                        }
                                    }
                                </div>
                                @if (addedPermissions.length) {
                                    <div class="flex flex-col gap-1">
                                        <div>
                                            Added:
                                        </div>
                                        <div class="flex flex-col gap-1 overflow-y-auto max-h-[20ch]">
                                            @for (permission of addedPermissions ; track permission) {
                                                <div class="flex flex-row bg-lime-700 rounded shadow-sm p-1 pl-2 text-slate-50">
                                                    <div class="grow">{{ permission }}</div>
                                                    <button (click)="onAddPermission(permission)">
                                                        +
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                                @if (removedPermissions.length) {
                                    <div class="flex flex-col gap-1">
                                        <div>
                                            Removed:
                                        </div>
                                        <div class="flex flex-col gap-1 overflow-y-auto max-h-[20ch]">
                                            @for (permission of removedPermissions ; track permission) {
                                                <div class="flex flex-row bg-red-700 rounded shadow-sm p-1 pl-2 text-slate-50">
                                                    <div class="grow">{{ permission }}</div>
                                                    <button (click)="onAddPermission(permission)" class="text-white">
                                                        +
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="h-[1px]"></div>
                </div>
                <!-- Cancel and Save -->
                <div class="grid grid-cols-2 text-slate-50 stroke-slate-50 bg-ponder-xlight p-2 rounded-b" [ngClass]="{'hidden' : isSaving }">
                    <button (click)="onCancelClicked()" class="flex flex-row gap-2 items-center align-middle justify-center group hover:cursor-pointer hover:text-ponder-bright hover:stroke-ponder-bright">
                        <div>
                            Cancel
                        </div>
                    </button>
                    <button (click)="onSaveClicked()" class="flex flex-row gap-2 items-center align-middle justify-center group hover:cursor-pointer hover:text-ponder-bright hover:stroke-ponder-bright">
                        <div>
                            Save
                        </div>
                    </button>
                </div>
                <!-- Progress -->
                <div class="flex flex-col items-center align-middle justify-center min-h-[200px]" [ngClass]="{'hidden' : !isSaving}">
                    <loading [isLoading]="isSaving" [success]="saveSuccessful"></loading>
                </div>
            </div>
        </div>
    </div>
}